'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _a11y = require('./a11y');

var _a11y2 = _interopRequireDefault(_a11y);

var _events = require('./events');

var _events2 = _interopRequireDefault(_events);

var _image = require('./image');

var _image2 = _interopRequireDefault(_image);

var _relay = require('./relay42');

var _relay2 = _interopRequireDefault(_relay);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _searchV = require('./search-v2');

var _searchV2 = _interopRequireDefault(_searchV);

var _telefoon = require('./telefoon');

var _telefoon2 = _interopRequireDefault(_telefoon);

var _breakpoints = require('./breakpoints.constants');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _cbCssFeature = require('./cb-css-feature.directive');

var _cbCssFeature2 = _interopRequireDefault(_cbCssFeature);

var _imageLazyLoader = require('./imageLazyLoader/imageLazyLoader.directive');

var _imageLazyLoader2 = _interopRequireDefault(_imageLazyLoader);

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _forms = require('./forms');

var _forms2 = _interopRequireDefault(_forms);

var _graph = require('./graph');

var _graph2 = _interopRequireDefault(_graph);

var _webapi = require('./webapi');

var _webapi2 = _interopRequireDefault(_webapi);

var _cbsi = require('./cbsi');

var _cbsi2 = _interopRequireDefault(_cbsi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('cb.core', [_api2.default.name, _a11y2.default.name, _events2.default.name, _image2.default.name, _relay2.default.name, _search2.default.name, _searchV2.default.name, _telefoon2.default.name, _cbCssFeature2.default.name, _util2.default.name, _imageLazyLoader2.default.name, _forms2.default.name, _graph2.default.name, _webapi2.default.name, _cbsi2.default.name]).constant('BreakpointsConstants', _breakpoints2.default);

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/index.js
// module id = 812
// module chunks = 0